import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { BellRing, Check, X } from "lucide-react";

export default function WatchButton({ productId, testId }) {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [count, setCount] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post(`/products/${productId}/watchlist`, { email });
      setCount(data.count);
      setDone(true);
      toast.success("We'll email you when it's back");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not subscribe");
    } finally { setBusy(false); }
  };

  if (done) {
    return (
      <div className="inline-flex items-center gap-2 border border-[#CCFF00]/40 bg-[#CCFF00]/5 px-4 py-3 font-mono text-xs uppercase tracking-[0.2em] text-[#CCFF00]">
        <Check className="w-4 h-4" /> You&apos;re on the list{count ? ` · ${count} watching` : ""}
      </div>
    );
  }

  if (!open) {
    return (
      <button
        type="button"
        data-testid={testId}
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-2 border border-white/20 hover:border-white/50 font-mono uppercase tracking-[0.2em] text-xs px-5 py-3"
      >
        <BellRing className="w-4 h-4" /> Notify me when back
      </button>
    );
  }

  return (
    <form onSubmit={submit} className="inline-flex items-stretch gap-2 border border-white/20 bg-[#0A0A0A] p-1.5">
      <input
        data-testid={`${testId}-email`}
        type="email"
        required
        placeholder="you@example.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="brutal-input px-3 py-2 min-w-[240px] text-sm"
      />
      <button
        data-testid={`${testId}-submit`}
        type="submit"
        disabled={busy}
        className="bg-[#CCFF00] text-black font-mono text-xs uppercase tracking-[0.2em] px-4 disabled:opacity-40"
      >
        {busy ? "…" : "Notify"}
      </button>
      <button
        type="button"
        onClick={() => setOpen(false)}
        className="px-2 hover:bg-white/10"
        aria-label="Close"
      >
        <X className="w-4 h-4" />
      </button>
    </form>
  );
}
